import { render, staticRenderFns } from "./BulkUploadDetails.vue?vue&type=template&id=64dfd454&scoped=true"
import script from "./BulkUploadDetails.vue?vue&type=script&lang=js"
export * from "./BulkUploadDetails.vue?vue&type=script&lang=js"
import style0 from "./BulkUploadDetails.vue?vue&type=style&index=0&id=64dfd454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dfd454",
  null
  
)

export default component.exports